import React from 'react';
import FilterIcon from '../../../assests/img/filter.svg?react';
import '../../../assests/css/nofilter.scss';
import classNames from 'classnames';

export interface noContentProps {
    mainImage: React.ReactElement
    textToDisplay: string
    cta: React.ReactElement
    showIcon?: boolean,
    customClassName?: string,
}

export default function NoContent(props: noContentProps) {
    const {mainImage, textToDisplay, cta, customClassName, showIcon} = props;

    return (
        <div className={classNames('no-filters-container', customClassName ? customClassName : '')}>
            <div className="no-filters-image">
                {mainImage}
            </div>
            <div className="no-filters-text-container mb-3">
                {showIcon && (
                <span className="filter-image">
                    <FilterIcon width={"16"} height={"16"}/>
                </span>
                )}
                <span className="no-filters-text">
                    {textToDisplay}
                </span>
            </div>
            <>{cta}</>
        </div>
    );

}